export default __webpack_public_path__ + "static/media/blackM.66259ae5.jpg";